import findAllFor from '../filters/find-all-for';

const getRemoveConstraintForElement = (element) => {
  const constraints = findAllFor(element);

  return constraints.find((constraint) => constraint.removable);
};

export default getRemoveConstraintForElement;
